import { Button, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Loading from './Loading/Loading';
import { useLoading } from '../Context/LoadingContext';
import { handleLogOut } from '../helpers/Logout/Logout';
import ConfirmModal from './ConfirmModal';

const MainHeader = () => {

    const navigate = useNavigate();
    const { setLoading } = useLoading();

    const [openLogoutModal, setOpenLogoutModal] = useState(false);

    const confirmLogout = () => {
        setOpenLogoutModal(false);
        const token = localStorage.getItem('authToken');
        handleLogOut({ token, setLoading, navigate });
    };


    return (
        <>
            <Loading />
            <ConfirmModal
                open={openLogoutModal}
                onClose={() => setOpenLogoutModal(false)}
                onConfirm={confirmLogout}
                title="تأیید خروج"
                message="آیا مطمئن هستید که می‌خواهید از حساب کاربری خود خارج شوید؟"
            />
            <Grid width={'100%'} height={'70px'} bgcolor={'#2b3245'} p={{ xs: '8px', md: '16px' }} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                <Grid display={'flex'} alignItems={'center'} gap={{ xs: '4px', md: '8px' }}>
                    <Grid width={'60px'} height={'60px'} bgcolor={'transparent'} display={'flex'} alignItems={'center'} justifyContent={'center'} borderRadius={'4px'}>
                        <img src='/assets/images/AltynLogo.svg' alt='' style={{ width: '70%', height: '70%' }} />
                    </Grid>
                    <Typography variant='h4' color={'white'} fontWeight={700}>گروه آلتن</Typography>
                </Grid>
                <Grid>
                    <Typography variant='h5' color={'white'} fontWeight={700}></Typography>
                </Grid>
                <Grid display={'flex'} alignItems={'center'} gap={'8px'}>
                    <Button
                        onClick={() => setOpenLogoutModal(true)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '42px', px: '16px',
                            bgcolor: '#ff6100', color: 'white',
                            fontSize: '16px', borderRadius: '4px',
                            '&:hover': { bgcolor: '#DC5F00' }
                        }}>
                        خروج
                    </Button>
                </Grid>
            </Grid>
        </>

    )
}

export default MainHeader